import { useState } from "react";
// Hooks
import { useCheckAPI } from "../../hooks/useCheckAPI";
import { useUrlFilterState } from "../../hooks/useUrlFilterState";
// State Import
import { useSettledInvoiceList } from "../../state/settledInvoiceListState";
// Component imports
import { GenericListHeader } from "../../components/GenericHeader";
import { InvoiceTableFilterBar } from "../../components/InvoiceTableFilterBar";
import { InvoiceTable } from "../../components/InvoiceTable";
// MUI Imports
import Typography from "@mui/material/Typography";

export function SettledInvoiceList() {
  // List of invoices
  const [invoiceList, setInvoiceList] = useState({
    filter: {},
    invoice: [],
    paging: {},
  });

  // Invoice list filter defaults
  const [invoiceFilter, setInvoiceFilter] = useUrlFilterState(
    {
      search: "",
      page: 1,
      pageSize: 25,
    },
    { exclude: ["pageSize"] },
  );

  // Fetch list of invoices
  const { isError, data, error, isFetching, isSuccess } =
    useSettledInvoiceList(invoiceFilter);

  // Success Function
  const successFunc = () => setInvoiceList(data.data.data.data.list);
  // Error Function
  const errorFunc = () =>
    console.warn(`Error: ${data.data.status}: ${data.data.statusText}`);
  // Hook to check the BC API for errors
  useCheckAPI(isSuccess, data, data?.data?.status, successFunc, errorFunc);

  return (
    <>
      <GenericListHeader heading={"Settled Invoices"} />
      <InvoiceTableFilterBar
        invoiceFilter={invoiceFilter}
        setInvoiceFilter={setInvoiceFilter}
      />
      {isError && <Typography>Error: {error.message}</Typography>}
      <InvoiceTable
        data={invoiceList}
        loading={isFetching}
        invoiceFilter={invoiceFilter}
        setInvoiceFilter={setInvoiceFilter}
        type={"settled"}
      />
    </>
  );
}
